import muster from '@dbk-legacy/muster';

export default function modal() {
  let visible = false;

  return muster()
    .require('onDone', { call: true })
    .path('visible', {
      get({ res }) {
        return res.value(visible);
      },
      set({ req, res }) {
        visible = req.value;
        return res.ok();
      },
    })
    .path('done', {
      async call(_, { set, call }) {
        await set('visible', false);
        await call('onDone');
      },
    })
    .path('open', {
      async call(_, { set }) {
        await set('visible', true);
      },
    })
    .path('close', {
      async call(_, { set }) {
        await set('visible', false);
      },
    })
    .path('toggle', {
      async call(_, { set }) {
        await set('visible', !visible);
      },
    });
}
